const ACCESS_TOKEN_KEY = 'accessToken';

export const setAccessToken = (accessToken) => localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY);

export const getTokenProp = (property) => {
  const token = getAccessToken();

  try {
    const obj = token.split('.')[1];
    const payload = JSON.parse(window.atob(obj));
    return payload[property] ? payload[property] : null;
  } catch (parseError) {
    return null;
  }
};
